import { useContext } from "react";
import { useSelector } from "react-redux";
import { Gantt, GanttSort, Identifiable, Resource, Zone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  currentPage: number;
  canRetrieveNextElements: boolean;
  gantt: Gantt;
  retrieveGantt(request: Boundaries["retrieveGantt"]["request"]): void;
}

function useRetrieveGantt(
  size: number,
  sort: GanttSort,
  zone?: Identifiable<Zone>,
  resources?: Identifiable<Resource>[],
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveGanttRequestPending(size, sort, zone, resources),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveGanttRequestSuccess(size, sort, zone, resources),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveGanttRequestFailure(size, sort, zone, resources),
    ),
    gantt: useSelector(() => selector.getGantt(size, sort, zone, resources)),
    currentPage: useSelector(() =>
      selector.getGanttPage(size, sort, zone, resources),
    ),
    canRetrieveNextElements: useSelector(() =>
      selector.canRetrieveGantt(size, sort, zone, resources),
    ),
    retrieveGantt: core.retrieveGantt,
  };
}

export { useRetrieveGantt };
